var _path, _path2, _path3, _path4;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLogoNoIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 85,
    height: 20,
    viewBox: "0 0 85 20",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.44 1L12.17 1.25674V8.45483L11.9 8.71157H2.975L2.705 8.45483V1.25674L2.435 1H0.27L0 1.25674V18.7433L0.27 19H2.435L2.705 18.7433V11.2837L2.975 11.0269H11.9L12.17 11.2837V18.7433L12.44 19H14.605L14.875 18.7433V1.25674L14.605 1H12.44Z",
    fill: "#0000DC"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M24.0752 1L23.8052 1.25674V18.7433L24.0752 19H36.2452L36.5152 18.7433V16.9414L36.2452 16.6846H26.7802L26.5102 16.4279V11.2837L26.7802 11.0269H35.7052L35.9752 10.7702V8.9683L35.7052 8.71157H26.7802L26.5102 8.45483V3.56735L26.7802 3.31062H36.2452L36.5152 3.05388V1.25674L36.2452 1H24.0752Z",
    fill: "#0000DC"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M45.7148 1L45.4448 1.25674V18.7433L45.7148 19H57.3448L57.6148 18.7433V16.9414L57.3448 16.6846H48.4198L48.1498 16.4279V1.25674L47.8798 1H45.7148Z",
    fill: "#0000DC"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M81.7549 1L81.4849 1.25674L75.2649 15.6577H74.9949L68.7749 1.25674L68.5049 1H65.5249L65.2549 1.25674V18.7433L65.5249 19H67.6899L67.9599 18.7433V6.40095H68.2299L73.6399 18.7433L73.9099 19H76.3449L76.6149 18.7433L82.0249 6.40095H82.2949V18.7433L82.5649 19H84.7299L84.9999 18.7433V1.25674L84.7299 1H81.7549Z",
    fill: "#0000DC"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoNoIcon);
export default __webpack_public_path__ + "static/media/logo_no_icon.3cd0e566e2e0002f57f07df09222ce40.svg";
export { ForwardRef as ReactComponent };